import { create } from 'zustand';

interface BizyWidgetStore {
	isOpen: boolean;
	/**
	 * Conversation ID queued for the chat hook to load. The chat hook fetches
	 * the detail by id (shared React Query cache) and applies it through the
	 * same coherence-guarded path the dropdown uses — so the cross-component
	 * handoff only ever carries an id, never pre-fetched messages. This is what
	 * prevents a stale fetch from pairing one conversation's id with another's
	 * messages (BIZY-345).
	 */
	resumeConversationId: string | undefined;
	open: () => void;
	close: () => void;
	toggle: () => void;
	/** Open the widget and queue a conversation to load. */
	openWithConversation: (conversationId: string) => void;
	/** Queue a conversation to load without opening the widget (used by the side panel history list). */
	setResume: (conversationId: string) => void;
	/** Clear the pending resume id (called after the chat hook consumes it). */
	clearResume: () => void;
}

export const useBizyWidgetStore = create<BizyWidgetStore>((set) => ({
	isOpen: false,
	resumeConversationId: undefined,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false, resumeConversationId: undefined }),
	toggle: () => set((state) => ({ isOpen: !state.isOpen })),
	openWithConversation: (conversationId) => set({ isOpen: true, resumeConversationId: conversationId }),
	setResume: (conversationId) => set({ resumeConversationId: conversationId }),
	clearResume: () => set({ resumeConversationId: undefined }),
}));
